import {takeEvery,call,put,delay} from 'redux-saga/effects'
import {notification,message} from 'antd'
import axios from 'axios'
import firebaseApp from '../firebase'
import firebase  from 'firebase'




const db = firebaseApp.firestore();




function getQuestions(level){
   var data =  axios.get(`https://opentdb.com/api.php?amount=10&difficulty=${level}&type=multiple`)
    .then(data=>{return data})
    return data
}



function* startQuiz(action){
    yield put({type:"SET_LOADING",payload:true})
    const data = yield call(getQuestions,action.payload.level)
    if(data.status===200){
        const payload = {
            level:action.payload,
            questions:data.data.results,
            increasePoints:action.payload.increasePoints
        }
        yield put({type:"START_QUIZ",payload})
        notification.info({
            message: `GOOD LUCK ! Quiz started for ${action.payload.level} level`,
            description:
              'You have 10 seconds to answer each question',
              
            onClick: () => {
              notification.destroy();
            },
            placement:"bottomRight"
          });
         
    }else{
        const key = 'updatable';
        message.error({ content: 'Some Error occured ! Try Again', key, duration: 2 });
    }
    yield put({type:"SET_LOADING",payload:false})
}

function* endQuiz(action){
    const key = "updatable"
if(action.payload.coins>0){
    //INCREASE COINS AND REFETCH USER DATA AND RESET QUIZ
    console.log(action.payload)
    yield put({type:"RESET_QUIZ"})
    db.collection("users").doc(action.payload.userID).update({
        coins:firebase.firestore.FieldValue.increment(action.payload.coins),
        lastQuiz:Date.now()
      }).then(()=>{
        message.success({ content: ` ${action.payload.coins} Coins Added`, key, duration: 2 });
        
      }).catch((error)=>{
        message.error(error)
      })
     yield put({type:"UPDATE_COINS",payload:action.payload.coins})
    }else{
        yield put({type:"RESET_QUIZ"})
    }
    
}


export default function* quizSaga(){
    yield takeEvery("REQUEST_QUIZ_START",startQuiz)
    yield takeEvery("REQUEST_QUIZ_END",endQuiz)
}